import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { styled } from 'styled-components';

import { BackButton } from '../components/buttons/BackButton';
import { PassportOffer } from '../components/PassportOffer';
import { useUser } from '../providers/UserProvider';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  gap: 12px;
  padding-left: 12px;
  padding-right: 12px;
  margin-top: 20px;
`;

export const ReplayRoute = () => {
  const { userDetails } = useUser();
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    if (userDetails?.premiumGames?.includes('flagle')) {
      history.push(`/archive/${dayjs().format('YYYY-MM-DD')}`);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [history, userDetails?.premiumGames]);

  return (
    <Container>
      <BackButton />

      <div className="space-y-3 text-justify pb-3 mb-3 w-full">
        <h3 className="text-xl font-bold mb-3">{t('archive.replayGames')}</h3>
        {!userDetails?.premiumGames?.includes('flagle') && (
          <>
            <p className="mb-3">{t('archive.accessReplay')}</p>
            <PassportOffer />
          </>
        )}
      </div>
    </Container>
  );
};

export default ReplayRoute;
